
import Vue from "vue";
import AppPageSettingsBackgroundImage from "../document-settings/PageSettingsBackgroundImage.vue";
import AppPageSettingsDefault from "../document-settings/PageSettingsDefault.vue";
import AppPageSettingsFont from "../document-settings/PageSettingsFont.vue";
import AppSideBySideSettings from "./SideBySideSettings.vue";
import { ReportEngineSettings } from "@/utils/report-engine-settings/report-engine-settings";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => ReportEngineSettings,
			required: true
		}
	},
	components: {
		AppPageSettingsBackgroundImage,
		AppPageSettingsDefault,
		AppPageSettingsFont,
		AppSideBySideSettings
	},
	i18nEx: {
		componentPrefix: "components.reportengine"
	}
});
